<form class="action-form">
  <span class="title">{{ 'FORTNOX.CONNECT_HEADER' | translate }}</span>
  <div class="form-group">
    {{ 'FORTNOX.CONNECT_REDIRECT_INFO' | translate }}
  </div>
  <div>
    @if (fortnoxUrl) {
      <a class="btn btn-active" [href]="fortnoxUrl">{{ 'OK_BTN' | translate }}</a>
    }
    <button class="btn link-btn ml-2" (click)="close()">{{ 'CANCEL_BTN' | translate }}</button>
  </div>
</form>
